import { Button } from '@mui/material';
import useDisposalsGrid from './hooks/useDisposalsGrid';
import React from 'react';
import ListIcon from '@mui/icons-material/List';
import BaseFormGrid from '../../../components/grids/BaseFormGrid';
import DisposalOptionsModal from './DisposalOptionsModal';
import { ColDef } from 'ag-grid-community';
import DefaultColumnTypes from '../../../components/grids/columns/Column.constants';

const DisposalsGrid = () => {
    const {
        disposalRows,
        setAssetList,
        setShowOptionsModal,
        showOptionsModal,
        disposalsSummaryRow,
        canViewDisposalsReport,
    } = useDisposalsGrid();

    const reportColumnDefs: ColDef[] = [
        {
            field: 'number',
            headerName: 'Asset No',
            cellRenderer: 'agGroupCellRenderer',
            ...DefaultColumnTypes.ShortText,
        },
        {
            field: 'code',
            headerName: 'Asset Code',
            ...DefaultColumnTypes.MediumText,
        },
        {
            field: 'name',
            headerName: 'Asset Name',
            ...DefaultColumnTypes.MediumText,
        },
        {
            field: 'acquireDate',
            headerName: 'Acquire Date',
            ...DefaultColumnTypes.DateOnly,
        },
        {
            field: 'inServiceDate',
            headerName: 'In Service Date',
            ...DefaultColumnTypes.DateOnly,
        },
        {
            field: 'disposalDate',
            headerName: 'Disposal Date',
            ...DefaultColumnTypes.DateOnly,
        },
        {
            field: 'totalCost',
            headerName: 'Asset Cost',
            ...DefaultColumnTypes.Currency,
        },
        {
            field: 'totalDepreciation',
            headerName: 'Total Depreciation',
            ...DefaultColumnTypes.Currency,
            minWidth: 140,
        },
        {
            field: 'remainingValue',
            headerName: 'Asset Value',
            ...DefaultColumnTypes.Currency,
            minWidth: 130,
        },
        {
            field: 'settlement',
            headerName: 'Settlement',
            ...DefaultColumnTypes.Currency,
            minWidth: 130,
        },
        {
            field: 'disposalGainLoss',
            headerName: 'Disposal Gain (Loss)',
            resizable: false,
            ...DefaultColumnTypes.AccountingCurrency,
        },
    ];

    return (
        <React.Fragment>
            <BaseFormGrid
                title="Disposal Report"
                displayGrid={canViewDisposalsReport}
                isLoading={false}
                rowData={disposalRows}
                columnDefs={reportColumnDefs}
                gridClass="full-size-item"
                displaySummaryRow={true}
                pinnedBottomRowData={disposalsSummaryRow}
                displayToolbar={true}
                displayExportDataButton={true}
                toolbarChildren={
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => setShowOptionsModal(true)}
                        startIcon={<ListIcon />}>
                        Options
                    </Button>
                }></BaseFormGrid>
            <DisposalOptionsModal
                open={showOptionsModal}
                onAssetDisposalsLoaded={(assets) => setAssetList(assets)}
                onClose={() => setShowOptionsModal(false)}
            />
        </React.Fragment>
    );
};
export default DisposalsGrid;
